import { BaseReq, PaginationReq, PaginationResp, UpdaterResp } from "@/core/interface";

class BrandBaseReq extends BaseReq {
  name: string = "";
  enName: string = "";
  materialCategoryId: string[] = [];
  remark: string = "";
}

export class BrandReq extends BrandBaseReq {
  constructor(req = {}) {
    super();
    this.merge(req);
  }
}

export class BrandPageReq extends PaginationReq {
  materialCategoryId: string | undefined = undefined;
  name: string | undefined = undefined;
}

class BrandRecord {
  bizNo: string = "";
  name: string = "";
  enName: string = "";
  materialCategoryNames: string[] = [];
}

export class BrandPageResp extends PaginationResp<BrandRecord> {}

export class BrandListReq extends PaginationReq {
  constructor(req = {}) {
    super();
    this.merge(req);
  }
}

export class BrandListResp extends UpdaterResp {
  id: string = "";
  name:string="";
}

export class BrandDetailResp extends UpdaterResp {
  id: number = 0;
  name: string = "";
}
